var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentsTabIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 13,
    height: 13,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 18.4616V5.5385C18.6665 4.52035 17.8692 3.69235 16.8887 3.69235H15.1109V1.84619H13.3332V3.69235H7.99984V1.84619H6.22206V3.69235H4.44428C3.46384 3.69235 2.6665 4.52035 2.6665 5.5385V18.4616C2.6665 19.4797 3.46384 20.3077 4.44428 20.3077H16.8887C17.8692 20.3077 18.6665 19.4797 18.6665 18.4616ZM7.99984 16.6154H6.22206V14.7693H7.99984V16.6154ZM7.99984 12.9231H6.22206V11.077H7.99984V12.9231ZM11.5554 16.6154H9.77762V14.7693H11.5554V16.6154ZM11.5554 12.9231H9.77762V11.077H11.5554V12.9231ZM15.1109 16.6154H13.3332V14.7693H15.1109V16.6154ZM15.1109 12.9231H13.3332V11.077H15.1109V12.9231ZM16.8887 8.30773H4.44428V6.46158H16.8887V8.30773Z",
    fill: "#244B69"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_570_77)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.889,
    cy: 17.5385,
    rx: 5.33333,
    ry: 5.53846,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.889 13.0386C14.4957 13.0386 12.5557 15.0533 12.5557 17.5386C12.5557 20.0239 14.4957 22.0386 16.889 22.0386C19.2823 22.0386 21.2223 20.0239 21.2223 17.5386C21.2223 15.0533 19.2823 13.0386 16.889 13.0386ZM17.2632 19.9784V20.6122H16.6794V19.9855C15.7214 19.8493 15.3019 19.0319 15.3019 19.0319L15.8982 18.5139C15.8982 18.5139 16.279 19.2022 16.9677 19.2022C17.3482 19.2022 17.6368 18.9907 17.6368 18.6294C17.6368 17.7847 15.4453 17.8872 15.4453 16.3202C15.4453 15.6391 15.9641 15.1483 16.6791 15.0322V14.399H17.2629V15.0322C17.7614 15.1003 18.3517 15.3728 18.3517 15.9589V16.4085H17.5777V16.1905C17.5777 15.9657 17.3019 15.8159 16.9934 15.8159C16.5998 15.8159 16.3115 16.0202 16.3115 16.3063C16.3115 17.1714 18.5029 16.9602 18.5029 18.6021C18.5029 19.2771 18.0175 19.8623 17.2632 19.9784Z",
    fill: "#244B69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_570_77"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6667,
    height: 11.0769,
    fill: "white",
    transform: "translate(11.5557 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsTabIcon);
export default __webpack_public_path__ + "static/media/PaymentsTabIcon.450c636bbff2488a486b08cbdddf51e9.svg";
export { ForwardRef as ReactComponent };